<template>
  <cTable
		branch
  >
  </cTable>
</template>

<script>

import cTable from "@/view/finances/storage_bill";

export default {
  name: "branch_storage_bill",
	components:{
		cTable
	}
};
</script>
